import { Component } from '@angular/core';

@Component({
  selector: 'lausd-footer',
  templateUrl: './lausd.footer.component.html',
  styleUrls: ['./lausd.footer.component.scss'],
})
export class LausdFooterComponent {
  constructor() {}
}
